import { render, staticRenderFns } from "./ageGate.vue?vue&type=template&id=554c0030&"
import script from "./ageGate.vue?vue&type=script&lang=js&"
export * from "./ageGate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoFooter: require('/builds/2oYM8JSf/1/mcp/sk-soutez-2022/frontend/components/InfoFooter.vue').default})
